import { apiService } from './apiService';

// Helper function to convert snake_case to camelCase
const toCamelCase = (obj) => {
  if (!obj) return obj;
  
  const camelObj = {};
  Object.keys(obj)?.forEach(key => {
    const camelKey = key?.replace(/_([a-z])/g, (g) => g?.[1]?.toUpperCase());
    camelObj[camelKey] = obj?.[key];
  });
  return camelObj;
};

// Helper function to convert camelCase to snake_case
const toSnakeCase = (obj) => {
  if (!obj) return obj;
  
  const snakeObj = {};
  Object.keys(obj)?.forEach(key => {
    const snakeKey = key?.replace(/[A-Z]/g, letter => `_${letter?.toLowerCase()}`);
    snakeObj[snakeKey] = obj?.[key];
  });
  return snakeObj;
};

export const contentService = {
  // Get all content items
  async getAll(filters = {}) {
    try {
      const data = await apiService.getContent(filters);
      return data || [];
    } catch (error) {
      console.error('Error fetching content:', error);
      throw error;
    }
  },

  // Get single content item
  async getById(id) {
    try {
      const data = await apiService.getContent({ id });
      return data?.[0] || null;
    } catch (error) {
      console.error('Error fetching content item:', error);
      throw error;
    }
  },

  // Create new content item
  async create(contentData, userId) {
    try {
      const result = await apiService.createContent(contentData);
      return result;
    } catch (error) {
      console.error('Error creating content:', error);
      throw error;
    }
  },

  // Update content item
  async update(id, contentData) {
    try {
      // Send update request to API
      const response = await fetch('/api/content/update.php', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${apiService.token}`
        },
        body: JSON.stringify({ id, ...contentData })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to update content');
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating content:', error);
      throw error;
    }
  },

  // Delete content item
  async delete(id) {
    try {
      await apiService.deleteContent(id);
      return true;
    } catch (error) {
      console.error('Error deleting content:', error);
      throw error;
    }
  },

  // Bulk delete content items
  async bulkDelete(ids) {
    try {
      for (const id of ids) {
        await apiService.deleteContent(id);
      }
      return true;
    } catch (error) {
      console.error('Error bulk deleting content:', error);
      throw error;
    }
  },

  // Note: Real-time subscriptions are not supported with simple HTTP API
  // If needed, implement polling or WebSockets
  subscribeToChanges(callback) {
    // Placeholder for compatibility
    console.warn('Real-time subscriptions are not supported with HTTP API');
    return () => {};
  }
};
